import { jsx, css } from '@emotion/react';

import { connectLocation } from './location/LocationConnectors';
import Theme from '../themes/index';

const themeStyles = css`
  &:hover {
    color: ${Theme.colors.brand};
  }
`;

const BreadcrumbItem = ({ text, ...props }) => (
  <li>
    <a css={themeStyles} {...props}>
      {text}
    </a>{' '}
    <span aria-hidden="true" />
  </li>
);

const BreadcrumbItems = ({ items }) =>
  items.map(item => <BreadcrumbItem key={[item.text, item.href]} {...item} />);

const Breadcrumbs = connectLocation(({ items, t }) => (
  <ul className="oc-breadcrumbs" aria-label={t('breadcrumb')}>
    <BreadcrumbItems items={items} />
  </ul>
));
Breadcrumbs.WrappedComponent.displayName = 'Breadcrumbs';

export default Breadcrumbs;
